import React from 'react';
import { FeedbackMessageBannerProps } from './FeedbackMessageBanner.types';

export type FeedbackVariant = 'info' | 'success' | 'warning' | 'error';

const VARIANT_CLASSES: Record<string, string> = {
  error: 'text-color-destructive-activeSelected',
  warning: 'text-color-warning-activeSelected',
  success: 'text-color-success-activeSelected',
  info: '',
};

export const FeedbackMessageBanner: React.FC<FeedbackMessageBannerProps> = ({
  message,
  variant = 'info',
  className = 'book primary-text-color-submain-normal',
  reserveEmptyPlaceholder = false,
}) => {
  return (
    <p
      className={`
        flex items-center justify-center text-center break-words
        c1 bold w-full max-w-[37ch] mx-auto justify-self-center
        ${reserveEmptyPlaceholder ? '' : 'form-min-height'}
        ${VARIANT_CLASSES[variant] ?? ''} ${className}
      `}
      style={{ margin: 0 }}
      role={variant === 'error' ? 'alert' : 'status'}
      aria-live={variant === 'error' ? 'assertive' : 'polite'}
      aria-atomic="true"
    >
      {message}
    </p>
  );
};
